import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
} from "@angular/core";
import * as FileSaver from "file-saver";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { DashboardService } from "../../../../core/services/dashboard.service";
import { QR1ReportsDto } from "../../../../core/models/dashboard/qr1ReportsDto";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { LoaderService } from "../../../../core/services/loader.service";
import { GetProjectInvoiceReportRequestDto } from "../../../../core/models/orders/getProjectInvoiceReportRequestDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../../../orders/components/order-summary/order-summary.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { PdfViewerPageComponent } from "../../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";

@Component({
  selector: "jni-qr1-complete",
  templateUrl: "./qr1-complete.component.html",
  styleUrls: ["./qr1-complete.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    ClientDetailsComponent,
  ],
})
export class Qr1CompleteComponent implements OnInit, OnDestroy {
  qr1List: QR1ReportsDto[] = [];
  showSmallLoader = false;
  orderDisplayModal = false;
  saleOrderId = "";
  clientDisplayModal = false;
  clientId = "";
  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() closeEvent = new EventEmitter();

  constructor(
    private _dashboardService: DashboardService,
    private _loaderService: LoaderService,
    private renderer: Renderer2,
    private _toastr: JniToastrService,
    private _orderSummary: OrderSummaryService
  ) {}

  ngOnInit(): void {
    this.getQR1Reports();
    this.getJNIDeletedRecordsQueueTrigger();
  }
  getQR1Reports() {
    this.showSmallLoader = true;
    this._loaderService.setLoaderState(true);
    this._dashboardService.getCustomerAging(0).subscribe({
      next: res => {
        this.qr1List = res.data;
        this._loaderService.setLoaderState(false);
        this.showSmallLoader = false;
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this.showSmallLoader = false;
      },
    });
  }

  redirectToSummary(saleOrderId: string) {
    //this._router.navigate(['orders/order-summary/' + saleOrderId]);
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
  }

  redirectToClientSummary(customerAccountNumber: string) {
    if (customerAccountNumber) {
      this.clientId = customerAccountNumber;
      this.clientDisplayModal = true;
    }
  }

  onClose() {
    this.closeEvent.emit();
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  getProjectInvoiceReport(invoiceNumber: string, invoiceDate: string) {
    this._loaderService.setLoaderState(true);
    const reportObject = {
      InvoiceDate: invoiceDate,
      ProjectInvoiceId: invoiceNumber,
    } as GetProjectInvoiceReportRequestDto;

    this._orderSummary.getProjectInvoiceReport(reportObject).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res?.data?.reportBase64String) {
          PdfViewerPageComponent.openInNewTab(
            res.data.reportBase64String,
            `Invoice-${invoiceNumber}`
          );

          // const blob = this.b64toBlob(
          //   res.data.reportBase64String,
          //   "application/pdf"
          // );
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl);
        } else {
          this._toastr.error("Error", res.message);
          return;
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.error("Error", "Failed To Load PDF");
      },
    });
  }

  exportQuadReport1() {
    this.exportExcelForFilterData(this.qr1List);
  }

  exportExcelForFilterData(filterclientlist: QR1ReportsDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["CB Days"]: datum.cbDays,
        ["Invoice"]: datum.invoice,
        ["Client"]: datum.client,
        ["Job Name"]: datum.jobName,
        ["Total Amt"]: datum.totalAmount,
        ["Open Amt"]: datum.openAmount,
        ["Payments"]: datum.payments,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "ChargebackAgingReport");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  getJNIDeletedRecordsQueueTrigger() {
    this._dashboardService.getJNIDeletedRecordsQueueTrigger().subscribe();
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  addScollHiddenClass() {
    this.renderer.addClass(document.body, "p-overflow-hidden");
  }

  closeModalForClient() {
    this.clientDisplayModal = false;
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  setEmailData(obj: QR1ReportsDto) {
    const email = "ar@nadel.com";
    const subject = `Chargeback - Inv-${obj.invoice} - ${obj.client}  - ${obj.clientId}`;
    const body = `Regarding Customer ${obj.client} and Inv-${obj.invoice}. CB Days are at ${obj.cbDays}, Open amount $ ${obj.openAmount}`;

    return `mailto:${email}?subject=${subject}&body=${body}`;
  }
}
